import {memo} from 'react';

import PropTypes from 'prop-types';

import WarningIcon from '@/assets/icons/WarningIcon.svg';

import './IconExclamation.scss';

function IconExclamation({id, onClick}) {
  return (
    <div
      id={`${id ? `${id}` : 'icon-exclamation'}`}
      className="icon-exclamation-button"
      onClick={onClick}
    >
      <img
        id={`${id ? `${id}` : 'icon-exclamation-img'}`}
        className="icon-exclamation-img"
        alt={WarningIcon}
        src={WarningIcon}
      />
    </div>
  );
}

IconExclamation.propTypes = {
  id: PropTypes.string,
  onClick: PropTypes.func,
};

IconExclamation.defaultProps = {
  id: '',
  onClick: () => {},
};

export default memo(IconExclamation);
